"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PatientAllergiesUpdateRequestSchema () {
        return PatientAllergiesUpdateRequestSchema;
    },
    get PatientAllergiesUpdateResponseSchema () {
        return PatientAllergiesUpdateResponseSchema;
    }
});
const _zod = require("zod");
const _allergystatus = require("./allergy-status");
const _patientcreate = require("./patient-create");
const PatientAllergiesUpdateRequestSchema = _zod.z.object({
    noKnownAllergies: _zod.z.boolean({
        error: 'Select whether the patient has no known allergies.'
    }),
    allergies: _patientcreate.PatientAllergiesSchema,
    expectedRecordedAt: _zod.z.string({
        error: 'Expected recorded time is required.'
    }).datetime({
        offset: true,
        error: 'Expected recorded time must be an ISO-8601 datetime.'
    }).nullable()
}).strict().superRefine(_patientcreate.checkNoKnownAllergies);
const PatientAllergiesUpdateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    allergyStatus: _allergystatus.AllergyStatusSchema,
    allergyStatusRecordedAt: _zod.z.string().datetime({
        offset: true
    }).nullable()
});
